import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal } from "@mantine/core";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PowerContent from "./PowerContent";
import { downloadAgreementPdf } from "../../components/utils/airlineUtils";

const PowerModal = ({
  isOpen,
  onRequestClose,
  agreementDetails,
  activeTab,
  onSignedPoaUploaded,
}) => {
  const componentRef = useRef();
  const fileInputRef = useRef(null);

  const [backdropopen, setbackdropopen] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const isMobile = window.innerWidth < 768;
  const isLufthansa = Boolean(agreementDetails?.isLufthansa);

  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: "3000" }} open={backdropopen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        opened={isOpen}
        onClose={onRequestClose}
        contentLabel="Power Of Attorney Modal"
        ariaHideApp={false}
        size={"800px"}
        padding={"md"}
        fullScreen={isMobile}
        title="Power of Attorney"
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <PowerContent
              ref={componentRef}
              setbackdropopen={setbackdropopen}
              onRequestClose={onRequestClose}
              agreementDetails={agreementDetails}
              activeTab={activeTab}
              isModal={true}
            />
          </div>

          {isLufthansa && (
            <div
              style={{
                marginTop: "20px",
                padding: "16px",
                backgroundColor: "#f0f7ff",
                border: "1px solid #bbdefb",
                borderRadius: "8px",
                textAlign: "left",
              }}
            >
              {/* <p
                style={{
                  margin: "0 0 6px 0",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#0d47a1",
                }}
              >
                Lufthansa Physical Wet-Ink Signature Required for Power of Attorney
              </p> */}
              <p
                style={{
                  margin: "0 0 12px 0",
                  fontSize: "13px",
                  color: "#37474f",
                  lineHeight: "1.5",
                }}
              >
                1. Click <strong>Download PDF</strong> or <strong>Print</strong> below to obtain your Power of Attorney document.<br />
                2. Print the document and have all passengers physically sign it with a pen.<br />
                3. Click <strong>Upload Signed Power of Attorney</strong> below to upload the signed file.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  style={{
                    backgroundColor: "#0d47a1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={async () => {
                    setbackdropopen(true);
                    try {
                      await downloadAgreementPdf(
                        componentRef.current,
                        "Lufthansa_Group_Power_Of_Attorney.pdf"
                      );
                    } finally {
                      setbackdropopen(false);
                    }
                  }}
                >
                  Download Power of Attorney (PDF)
                </button>

                <button
                  type="button"
                  style={{
                    backgroundColor: "#2e7d32",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  Upload Signed Power of Attorney
                </button>

                {/* <button
                  type="button"
                  style={{
                    backgroundColor: "#f5f5f5",
                    color: "#333",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={handlePrint}
                >
                  Print
                </button> */}

                <button
                  type="button"
                  style={{
                    backgroundColor: "#757575",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                  onClick={onRequestClose}
                >
                  Close
                </button>

                <input
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf,.png,.jpg,.jpeg"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      if (onSignedPoaUploaded) {
                        onSignedPoaUploaded(file);
                      }
                      onRequestClose();
                      import("sweetalert2").then(({ default: Swal }) => {
                        Swal.fire({
                          icon: "success",
                          title: "Signed Power of Attorney Uploaded",
                          text: `${file.name} uploaded successfully!`,
                          confirmButtonColor: "#0d47a1",
                        });
                      });
                    }
                  }}
                />
              </div>
            </div>
          )}

          {!isLufthansa && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              {/* <button
                type="button"
                style={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
                onClick={handlePrint}
              >
                Print
              </button> */}
              <button
                type="button"
                style={{
                  backgroundColor: "#757575",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
                onClick={onRequestClose}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default PowerModal;
